import React from 'react';

function renderTextField(field){
  const {meta: {touched, error} } = field;

  if(field.withLabel){
    return (
      <div className={`form-group ${field.dynamicClass}`}>
        <label> {field.title}</label>
        <input className='form-control' type="text" placeholder={field.placeholder} {...field.input}/>
        <div className="ErrorField"> {touched ? error:" "} </div>
      </div>
    );
  }else{
    return(
      <div className={field.dynamicClsass}>
        <input className={`form-control`} type="text" placeholder={field.placeholder} {...field.input}/>
        <div className="ErrorField"> {touched ? error:" "} </div>
      </div>
    );
  }
}
function renderCreditCardField(field){
  const {meta: {touched, error} } = field;
  return(
    <div className={field.dynamicClass}>
      <input className={`form-control`} type="text" placeholder={field.placeholder} {...field.input}/>
      <div className="ErrorField"> {touched ? error:" "} </div>
    </div>
  );
}

function renderDropdownField(field){
  if(field.withLabel){
    return (
      <div className={`form-group ${field.dynamicClass}`}>
        <label> {field.title} </label>
        <select className="form-control" {...field.input}>
          {field.options.map((op)=>{
            return(<option key={op.value} defaultValue={op.value}> {op.display} </option>);
          })}
        </select>
      </div>
    );
  }else{
    return(
        <select className={`form-control ${field.dynamicClass}`} {...field.input}>
          {field.options.map((op)=>{
            return(<option key={op.value} defaultValue={op.value}> {op.display} </option>);
          })}
        </select>
    );
  }
}

 function renderCheckBoxField({input, value, label}){
  return (
    <div>
      <input {...input} type="checkbox" value={value} />
      <label>{label}</label>
    </div>
  );
}

export function renderRadioButton({input, name, value, label, dynamicClass}){
  return(
    <div className={dynamicClass}>
      <input {...input} type="radio" name={name} value={value} />
      <label>{label}</label>
    </div>
  )
}

export function renderTextAreaField({input, value, label, dynamicClass}){
  return (
    <div className={`form-group ${dynamicClass}`}>
      <label> {label} </label>
      <textarea className="form-control" {...input}> </textarea>
    </div>
  )
}

export {renderTextField, renderDropdownField, renderCheckBoxField, renderCreditCardField};



// WEBPACK FOOTER //
// ./src/components/orderPage2/renderCollection.js